export const EMAIL = "khushpatel075@gmail.com";
export const INSTAGRAM = "https://instagram.com/khushpatelphotography";

export const NAV_LINKS = [
  { id: "work", label: "Work", index: "01" },
  { id: "services", label: "Services", index: "02" },
  { id: "about", label: "About", index: "03" },
  { id: "contact", label: "Contact", index: "04" },
];

export const MARQUEE_TEXT =
  "KHUSH PATEL PHOTOGRAPHY • FILMMAKING • POST-PRODUCTION • READY WHEN YOU ARE • ";

export const FILTERS = ["All", "Fashion", "Filmmaking", "Concerts", "Landscape", "Post-Production"];

// Display flow for the "All" view: portraiture first, retouch next, then concerts + film, then the rest
export const GROUP_ORDER = { Fashion: 0, "Post-Production": 1, Filmmaking: 2, Concerts: 3, Landscape: 4 };

// Every tile carries two media slots: a static thumbnail and a hover-state
// video loop. Swap `thumb` / `hoverVideo` with real asset URLs when ready.
export const PROJECTS = [
  {
    id: "illenium-india-2024",
    index: "01",
    title: "ILLENIUM — INDIA TOUR 2024",
    role: "DOP / Edit & Grade",
    category: "Filmmaking",
    thumb: "/media/illenium-thumb.jpg",
    hoverVideo: "/media/illenium-loop.mp4",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "shadow-study",
    index: "02",
    title: "SHADOW STUDY",
    role: "Photographer / Retoucher",
    category: "Fashion",
    thumb: "/media/photo-shadow-study.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "terracotta-door",
    index: "03",
    title: "TERRACOTTA DOOR",
    role: "Photographer",
    category: "Fashion",
    thumb: "/media/photo-terracotta-door.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "retouch-series",
    index: "04",
    title: "RETOUCH SERIES",
    role: "Digital Retoucher — Photoshop",
    category: "Post-Production",
    thumb: "/media/retouch-eye.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "skyline-knits",
    index: "05",
    title: "SKYLINE KNITS",
    role: "Photographer",
    category: "Fashion",
    thumb: "/media/photo-skyline-knits.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "denim-paisley",
    index: "06",
    title: "DENIM & PAISLEY",
    role: "Photographer / Retoucher",
    category: "Fashion",
    thumb: "/media/photo-denim-paisley.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "sunburn-pyro",
    index: "07",
    title: "SUNBURN '23 — PYRO",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-sunburn-pyro.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "dvlm-mumbai",
    index: "08",
    title: "DVLM — MUMBAI",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-dvlm-mumbai.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "co2-cannons",
    index: "09",
    title: "CO2 CANNONS",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-co2-cannons.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "mid-air",
    index: "10",
    title: "MID-AIR — MAINSTAGE",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-mid-air.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "palm-tree-fest",
    index: "11",
    title: "PALM TREE FEST",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-palm-tree.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "color-block-7819",
    index: "12",
    title: "COLOR BLOCK — 7819",
    role: "Photographer — Published Editorial",
    category: "Fashion",
    thumb: "/media/fashion-color-block.webp",
    focus: "object-left",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "jeweled-gaze-1",
    index: "13",
    title: "JEWELED GAZE I",
    role: "Photographer / Retoucher — Published",
    category: "Fashion",
    thumb: "/media/beauty-jeweled-1.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "jeweled-gaze-2",
    index: "14",
    title: "JEWELED GAZE II",
    role: "Photographer / Retoucher — Published",
    category: "Fashion",
    thumb: "/media/beauty-jeweled-2.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "jeweled-gaze-3",
    index: "15",
    title: "JEWELED GAZE III",
    role: "Photographer / Retoucher — Published",
    category: "Fashion",
    thumb: "/media/beauty-jeweled-3.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "griffith-dusk",
    index: "16",
    title: "GRIFFITH — DUSK",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/city-griffith-dusk.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "griffith-frame",
    index: "17",
    title: "GRIFFITH — FRAMED",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/city-griffith-frame.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "la-river-mono",
    index: "18",
    title: "LA RIVER — MONO",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/city-la-river-mono.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "santa-monica-pier",
    index: "19",
    title: "SANTA MONICA PIER",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/city-santa-monica-pier.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "sixth-street",
    index: "20",
    title: "SIXTH STREET VIADUCT",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/city-sixth-street.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "hardwell-sunburn",
    index: "21",
    title: "HARDWELL — SUNBURN GOA",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-hardwell.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "sunburn-fireworks",
    index: "22",
    title: "SUNBURN — FIREWORKS",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-fireworks.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "teal-haze",
    index: "23",
    title: "TEAL HAZE",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-teal-haze.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "palm-tree-day",
    index: "24",
    title: "PALM TREE — DAY CROWD",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-day-crowd.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "sunburn-lasers",
    index: "25",
    title: "SUNBURN GOA — LASERS",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-sunburn-lasers.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "spotlight-decks",
    index: "26",
    title: "SPOTLIGHT — ON THE DECKS",
    role: "Concert Photographer",
    category: "Concerts",
    thumb: "/media/concert-spotlight-decks.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "desert-storm",
    index: "27",
    title: "DESERT STORM",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/land-desert-storm.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
  {
    id: "city-veil",
    index: "28",
    title: "CITY VEIL — DUSK",
    role: "Photographer",
    category: "Landscape",
    thumb: "/media/land-city-veil.webp",
    hoverVideo: "",
    thumbLabel: "",
    hoverLabel: "",
  },
];

export const SERVICES = [
  {
    id: "photography",
    index: "S/01",
    title: "PHOTOGRAPHY",
    description:
      "Cinematic portraits, highly stylized poster photography, and crisp low-light environments — frames built with intention, not luck.",
    tags: ["CINEMATIC PORTRAITS", "POSTER PHOTOGRAPHY", "LOW-LIGHT"],
  },
  {
    id: "filmmaking",
    index: "S/02",
    title: "FILMMAKING",
    description:
      "Technical on-set execution across commercials, music videos, and narrative projects — from DOP to camera operation to pulling focus.",
    tags: ["COMMERCIALS", "MUSIC VIDEOS", "NARRATIVE", "DOP / 1ST AC"],
  },
  {
    id: "post-production",
    index: "S/03",
    title: "POST-PRODUCTION",
    description:
      "Advanced color grading in DaVinci Resolve and precise digital retouching in Photoshop — the last 10% that makes the image undeniable.",
    tags: ["DAVINCI RESOLVE", "COLOR GRADING", "PHOTOSHOP RETOUCH"],
  },
];

export const CHAPTERS = [
  {
    index: "01",
    title: "ORIGINS",
    body: "Khush Patel picked up a camera at fourteen — a kid in India who once dreamed of flying planes, until art and light pulled harder. At sixteen he was interning under one of the country's leading photographers; at eighteen he shot his first international gig: Ultra Music Festival in Miami. That weekend became tours across five countries as a personal artist photographer — and eventually Khush Patel Photography, now based in Los Angeles.",
  },
  {
    index: "02",
    title: "PHILOSOPHY",
    body: "The work starts from an authentic place: a picture should tell a story too deep for words. Khush blends classic and contemporary influences, grounded in a real respect for the history of the medium — Ansel Adams' \"The Camera\" taught him intention and foresight before the shutter ever fires. Music drives the frame; curiosity, emotional intelligence, and a willingness to take the leap do the rest.",
  },
  {
    index: "03",
    title: "PRACTICE",
    body: "Seventy-five artists and counting. Concert, portrait, and commercial conceptual work — shot on set, then graded in DaVinci Resolve and retouched in Photoshop under one roof. Published in more than ten magazines worldwide and a Canon EOS influencer since 2021, the commercial work funds the passion projects, and the passion projects sharpen the commercial eye. Now pushing deeper into fashion and beauty.",
  },
];

export const PRESS = [
  { name: "VOYAGE LA", url: "https://voyagela.com/interview/daily-inspiration-meet-khush-patel/" },
  { name: "CANVAS REBEL", url: "https://canvasrebel.com/meet-khush-patel/" },
  { name: "BOLD JOURNEY", url: "https://boldjourney.com/meet-khush-patel/" },
  { name: "SHOUTOUT LA", url: "https://shoutoutla.com/meet-khush-patel/" },
];

export const FIELD = [
  { id: "crew-sunburn", src: "/media/field-crew-sunburn.webp", caption: "CREW HUDDLE — SUNBURN, IN" },
  { id: "the-pit", src: "/media/field-the-pit.webp", caption: "IN THE PIT — SUNBURN" },
  { id: "pole-cam", src: "/media/field-pole-cam.webp", caption: "POLE CAM — MAINSTAGE" },
  { id: "show-day", src: "/media/field-show-day.webp", caption: "SHOW DAY — LOAD-IN" },
  { id: "leap-riyadh", src: "/media/field-leap-riyadh.webp", caption: "LEAP TECH — RIYADH, KSA" },
];

export const ARTISTS = [
  "DANNY AVILA", "M4SHFT", "AFISHAL", "RÜFÜS DU SOL", "MARTIN GARRIX", "ARMIN VAN BUUREN",
  "DIMITRI VEGAS & LIKE MIKE", "HARDWELL", "TIMMY TRUMPET", "ED SHEERAN", "THE CHAINSMOKERS",
  "CALVIN HARRIS", "MESTO", "MADEON", "ZEDD", "SUBTRONICS", "WOOLI", "ILLENIUM", "BLACK COFFEE",
  "BEN BÖHMER", "BASSJACKERS", "MADDIX", "DISCO LINES", "SWEDISH HOUSE MAFIA", "MPH", "SLANDER",
  "JOHN SUMMIT", "DEADMAU5", "KASKADE", "ODESZA", "AFROJACK", "KEVIN DE VRIES", "KNOCK2", "DIPLO",
  "MARSHMELLO", "IMAGINE DRAGONS", "G-EAZY", "ANUV JAIN", "KUNAL MERCHANT", "KAHANI", "R3HAB",
  "FISHER", "CHRIS LAKE", "KING", "AP DHILLON", "ALAN WALKER", "SHAAN", "VINI VICI", "DJ BL3ND",
  "BADSHAH", "RAFTAAR", "KR$NA", "CHARLOTTE DE WITTE", "LAVERN", "W&W", "TIËSTO", "DOM DOLLA",
  "ALESSO", "ANYMA", "SOLOMUN", "GRIFFIN", "ALOK",
];
